export default __webpack_public_path__ + "static/Aeonik-BlackItalic-ccf4024b25eec28be340c3ce6c7f5007.otf";